module.exports = __webpack_public_path__ + "assets/gaozhong-silogan.d3ffe4f.png";